module.exports = __webpack_public_path__ + "img/logo.6c9f8775.svg";